'use strict';

module.exports = /* @ngInject */ function(headerService) {
	return {
		restrict: 'E',
		scope: {
		},
		templateUrl: `./${BUILD_PATH}/header-dropdown.directive.html`,
		controller: /* @ngInject */ function ($scope) {

			$scope.navigationItems = [];
			$scope.isOpen = {};

			$scope.navigate = navigate;

			init();

			function init(){
				getData();
			}

			function getData(){
				headerService.getNavigationItems.query().$promise.then((data) => {
					if(data && data.length){
						data.forEach((el) => $scope.isOpen[el.module] = false);
					}
					$scope.navigationItems = data;
				})
			}

			function navigate(navigationItem) {
				const navigateTo = headerService.getModuleNavigation(navigationItem.module);
				if (navigateTo) {
					if (typeof navigateTo === 'string') {
						window.openContent(navigateTo, navigationItem.title);
					} else if(typeof navigateTo === 'object' && navigateTo.iframeRoute && navigateTo.path){
						setIFrameRoute(navigateTo.iframeRoute);
						window.openContent(navigateTo.path, navigationItem.title);
					}
				}
			}
		}
	};
}
